import React, { useState, useEffect } from 'react';
import { getManagerLandingPath } from "@/shared/readOnlyManager";
import { Form, Field } from 'react-final-form';
import {login} from '../../App/auth';
import {isProgramManager, isProgramParticipant, hasRoleInProgram} from "@/shared/helpers"
import {useDispatch, flash422, flashSuccess} from "@/shared/components/flash"
import Select from 'react-select'
import { Input } from 'reactstrap';
import TemplateButton from "@/shared/components/TemplateButton"
import {useSearchParams} from "react-router-dom";
import { prepareUrlByDomain } from '@/shared/helpers';
import LoginAttemptWarningModal from './LoginAttemptWarningModal';
const axios = require('axios');
export const MEDIA_TYPES = [];

const LogInForm = ({ showResendActivationLink = false, onOpenResendActivation }) => {
  const [searchParams] = useSearchParams();
  const [ssoToken, setSsoToken] = useState(searchParams.get('sso-token') || null);
  const dispatch = useDispatch()
  // const organization = getOrganization()

  const [step, setStep] = useState(0);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(false);
  let [user, setUser] = useState(null);
  let [accessToken, setAccessToken] = useState(null);
  let [program, setProgram] = useState(null);
  const [isManager, setIsManager] = useState(false);
  const [isLimitedManager, setIsLimitedManager] = useState(false);
  const [isReadOnlyManager, setIsReadOnlyManager] = useState(false);
  const [isParticipant, setIsParticipant] = useState(false);
  const [mediaTypes, setMediaTypes] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);

  const ssoLogin = async ssoToken => {
    setStep(1)
    await axios.post('/sso-login', {
      sso_token: ssoToken
    }).then((res) => {
      if (res.status === 200) {
        if (!isProgramManager(res.data.user) && !isProgramParticipant(res.data.user)) {
          alert("You are logging into Wrong Login Area")
          return
        } else {
          setLoading(true)
          setStep(1)
          setUser(res.data.user)
          setOrganization(res.data.user.organization)
          setAccessToken(res.data.access_token)
          setLoading(false)

        }
      }
    })
      .catch(err => {
        if (err.response?.status === 429) {
          const retryAfter = err.response.headers['retry-after'] || 60;
          flash422(dispatch, `Too many login attempts. Please wait ${retryAfter} seconds.`);
        } else {
          window.location.href = '/user-not-found';
        }
      })
  };

  const handleCheckRole = ( programId ) => {
    setIsParticipant(false)
    setIsManager(false)
    setIsLimitedManager(false)
    setIsReadOnlyManager(false)
    if(hasRoleInProgram('Participant', programId, user)) {
      setIsParticipant(true)
    }
    if(hasRoleInProgram('Manager', programId, user)) {
      setIsManager(true)
    }
    if(hasRoleInProgram('Limited Manager', programId, user)) {
      setIsLimitedManager(true)
    }
    if(hasRoleInProgram('Read Only Manager', programId, user)) {
      setIsReadOnlyManager(true)
    }
  };

  const handleCountRole = ( ) => {
    let count = 0;
    let programId = null;
    let role = '';
    programOptions.forEach((option, index) =>{
      programId = option.value;
      if(hasRoleInProgram('Participant', programId, user)) {
        role = 'participant';
        count ++;
      }
      if(hasRoleInProgram('Manager', programId, user)) {
        role = 'manager';
        count ++;
      }
      if(hasRoleInProgram('Limited Manager', programId, user)) {
        role = 'limited_manager';
        count ++;
      }
      if(hasRoleInProgram('Read Only Manager', programId, user)) {
        role = 'read_only_manager';
        count ++;
      }
    })
    return [count, programId, role];
  };

  useEffect(() => {
    if (ssoToken !== null && ssoToken !== undefined){
      ssoLogin(ssoToken)
    }
  }, [ssoToken])

  useEffect( () => {
    // setUser(getAuthUser())
  }, [])

  useEffect( () => {
    if(user){
      let options = getProgramOptions(user);
      if(options.length > 0){
        setProgramOptions(options)
      }
    }
  }, [user])

  useEffect( () => {
    if(accessToken){
      if(programOptions.length){
        let option=programOptions[0];
        setProgram(option);
        let [roleCount, currentId, currentRole]=handleCountRole();

        if(roleCount==1){
          handleProgramLogin(currentId, currentRole)
        }else{
          handleCheckRole(option.value);
          setStep(1)
        }
      }
    }
  }, [programOptions, accessToken])

  const onClickForgotLink = (e) => {
    e.preventDefault();
    setStep(3);
  }

  const handleProgramLogin = async( programId, loginAs ) =>{
    try {
      if (!user?.programRoles || typeof user.programRoles[programId] === 'undefined') {
        throw new Error('Invalid login attempt');
      }

      const program = user.programRoles[programId];
      if (program.archive_program) {
        throw new Error("Program you want to login is archived");
      }

      const data = { role: loginAs };

      setLoading(true)
      const res = await axios.post(
        `/organization/${program.organization.id}/program/${programId}/login`,
        data,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      if (res.status === 429) {
        const retryAfter = res.headers['retry-after'] || 60;
        flash422(dispatch, `Too many login attempts. Please wait ${retryAfter} seconds.`);
      }
      
      if (res.status === 200) {
        const { program: loggedInProgram, role, isAdmin } = res.data;
        //console.log(user.hasCoCardProgram);return false;
        if (loggedInProgram && role) {
          if (isAdmin !== undefined) {
            user = { ...user, isAdmin };
          }
          user.loginAs = role;
          user.organization_id = program.organization.id;
          user.organization = program.organization;
        if(!user.hasCoCardProgram) {
            login({
                user,
                access_token: accessToken,
                program: loggedInProgram,
                rootProgram: loggedInProgram,
                organization: program.organization,
          });
        } else {
            login({
                user,
                access_token: accessToken,
                program: loggedInProgram,
                rootProgram: loggedInProgram,
                organization: program.organization,
            });
            const programDomain = user.programRoles[programId].domain;
            const domain = prepareUrlByDomain(programDomain);
            let payload = {
                "role_id": role.id
            }
            setLoading(true)
            const url = `/organization/${program.organization_id}/program/${program.id}/user/${user.id}/cocardLoginAs`;
            axios.post(url,
                payload,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            ).then((res) => {
                if (res.status === 200) {
                    const newWindow = window.open(domain, '_blank');

                    const handleReady = (event) => {
                        if (event.source !== newWindow) return;
                        if (event.data?.type === 'ready') {
                            window.removeEventListener('message', handleReady);
                            const auth = user;
                            const data = {
                                role,
                                auth,
                                access_token: accessToken,
                                organization_id: program.organization_id,
                                program_id: program.id,
                                user_id: user.id
                            };

                            newWindow.postMessage(data, domain);
                        }
                    };

                    window.addEventListener('message', handleReady);

                }
            })
            .catch(error => {
                // console.log(error.response.data);
                flash422(dispatch, error.response.data)
            })
            .finally(() => setLoading(false))
            return false;
        }
          let sendTo = '/';

          if (user.loginAs.name.includes('Manager')) {
            sendTo = getManagerLandingPath(user);
            setTimeout(() => {
              window.location = sendTo;

            }, 500);
          } else if (user.loginAs.name === 'Participant') {
            if(res.data.program.allow_loginto_enterprise_version_simply)
              sendTo = 'enterprise/loading/'
            else
              sendTo = 'participant/home'
            try {
              const mediaRes = await axios.get(
                `/organization/${program.organization.id}/program/${programId}/digital-media-type`,
                {
                  headers: { Authorization: `Bearer ${accessToken}` },
                }
              );
              localStorage.setItem(MEDIA_TYPES, JSON.stringify(mediaRes.data));
              setTimeout(() => {
                window.location = sendTo;
              }, 500);
            } catch (mediaErr) {
              console.error("Media fetch error:", mediaErr);
            }
          }
        } else {
          alert("Invalid Program");
        }
      }

    } catch (err) {
      flash422(dispatch, err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  const CardFormLogin = ()  => {
    const FormLogin = () => {
      const [loading, setLoading] = useState(false);
      const [value, setValue] = useState();
      const [verificationRequired, setVerificationRequired] = useState(false);
      const [passwordExpired, setPasswordExpired] = useState(false);
      const [userEmail, setUserEmail] = useState('');
      const [userPassword, setUserPassword] = useState('');
      const [showAttemptWarning, setShowAttemptWarning] = useState(false);

      const sendAgain = (e) => {
        e.preventDefault();
        generate2faSecret(value)
        .then(() => {
          flashSuccess(dispatch, 'New code sent');
        });
      }

      const backToLogin = (e) => {
        setVerificationRequired(false);
        e.preventDefault();
      }

      const backFromPasswordExpired = (e) => {
        e.preventDefault();
        setPasswordExpired(false);
      }

      const backFromExpired2FA = (e) => {
        e.preventDefault();
        setVerificationRequired(false);
      }

      const onExpired2FASubmit = async (values) => {
        if (!value?.email || !userPassword || !values?.code) return;
        setLoading(true);
        axios.post('/login', {
          email: value.email,
          password: userPassword,
          code: values.code,
        })
          .then((res) => {
            if (res.status === 200) {
              if (!isProgramManager(res.data.user) && !isProgramParticipant(res.data.user)) {
                alert("You are logging into Wrong Login Area");
                return;
              }
              setAccessToken(res.data.access_token);
              setOrganization(res.data.user.organization);
              setUser(res.data.user);
            }
          })
          .catch((err) => {
            flash422(dispatch, err.response?.data || err.message);
          })
          .finally(() => setLoading(false));
      };

      const validate = values => {
        let errors = {};
        if (!values.email) {
          errors.email = "Email is required";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(values.email)) {
          errors.email = "Invalid email address";
        }
        if (!values.password) {
          errors.password = "Password is required";
        }
        if (!values.code && verificationRequired){
          errors.code = "Code is required";
        }
        return errors;
      }

      const validateExpiredPassword = values => {
        let errors = {};
        if (!values.new_password) {
          errors.new_password = "New password is required";
        }
        if (!values.password_confirmation) {
          errors.password_confirmation = "Confirm password is required";
        } else if (values.new_password && values.new_password !== values.password_confirmation) {
          errors.password_confirmation = "Passwords do not match";
        }
        return errors;
      }

      const generate2faSecret = async (values) => {
        try {
          setLoading(true)
            const response = await axios.post('/generate-2fa-secret', values);
            if (response.status === 200) {
              // console.log("200")
              // setErrors(null);
              // setStep(2)
              setVerificationRequired(true);
            }
          } catch (error) {
              // setErrors(error.response.data);
          }
          finally{
            setLoading(false)
          }
      };

      const onSubmit = async values => {

        if(!verificationRequired) {
          delete values.code;
        }
        if (values.email){
          setUserEmail(values.email)
        }
        if (values.password){
          setUserPassword(values.password)
        }
        // console.log(values);
        setLoading(true)
        try {
          const res = await axios.post('/login', values);
          // console.log(res);
          // return;
          if(res.status === 200)  {
            // res.data.user.loginAs = 'Participant'
            if( !isProgramManager(res.data.user) && !isProgramParticipant(res.data.user) )  {
              alert("You are logging into Wrong Login Area")
              return
            } else {
              // if( isProgramManager(res.data.user) && isProgramParticipant(res.data.user) ) {
              //   setIsManager(true)
              //   setIsParticipant(true)
              //   // alert('Is Both');
              // } else if(isProgramManager(res.data.user)) {
              //   setIsManager(true)
              //   // alert('Is Manager');
              // } else if(isProgramParticipant(res.data.user)) {
              //   // alert('Is Participant');
              //   setIsParticipant(true)
              // }
              setAccessToken(res.data.access_token)
              setOrganization(res.data.user.organization)
              setUser(res.data.user)
              // var t = setTimeout(window.location = '/participant/home', 500)
            }
          }
        } catch(err) {
          if (err.response) {
            if (err.response?.status === 403 && err.response?.data?.force_password_reset === true) {
              setValue(values);
              setPasswordExpired(true);
            } else if (err.response.status === 403) {
              // 2FA handling — await so loading stays active until the 2FA form appears
              setValue(values);
              await generate2faSecret(values);
            } else if (err.response.status === 429) {
              // RATE LIMIT
              const retryAfter = err.response.headers['retry-after'] || 60;
              flash422(dispatch, `Too many login attempts. Please wait ${retryAfter} seconds and try again.`);
            } else if (err.response.status === 422 && err.response.data?.remaining_attempts === 1) {
              setShowAttemptWarning(true);
            } else {
              flash422(dispatch, err.response.data);
            }
          } else {
            flash422(dispatch, err.message);
          }
        } finally {
          setLoading(false);
        }
      };


      const onExpiredPasswordSubmit = async (values) => {
        if (!value?.email || !value?.password) return;
        setLoading(true);
        try {
          await axios.post('/password/expired-reset', {
            email: value.email,
            password: value.password,
            new_password: values.new_password,
            new_password_confirmation: values.password_confirmation,
          });
          setUserPassword(values.new_password);
          await generate2faSecret({ email: value.email });
          setVerificationRequired(true);
        } catch (err) {
          flash422(dispatch, err.response?.data || err.message);
        } finally {
          setLoading(false);
        }
      };

      if (passwordExpired) {
        if (verificationRequired) {
          return (
            <Form
              onSubmit={onExpired2FASubmit}
              validate={(values) => {
                const errors = {};
                if (!values.code) errors.code = "Code is required";
                return errors;
              }}
              initialValues={{ code: '' }}
              render={({ handleSubmit }) => (
                <form className="form" onSubmit={handleSubmit}>
                  <p className="mb-3 text-muted">Your password has expired.</p>
                  <p className="mb-3 text-muted">Enter the verification code sent to your email.</p>
                  <Field name="code">
                    {({ input, meta }) => (
                      <div className="mb-3">
                        <label htmlFor="expired2faCode" className="form-label">
                          Code sent to email <span className="text-blue">{value?.email || userEmail}</span>
                        </label>
                        <div className="form__form-group-field">
                          <div className="form__form-group-row">
                            <Input placeholder="Enter 2FA code" type="text" {...input} id="expired2faCode" autoFocus />
                            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                          </div>
                        </div>
                      </div>
                    )}
                  </Field>
                  <TemplateButton type="submit" className="" disabled={loading} text="Sign In" />
                  <div className="login-form-links">
                    <button
                      type="button"
                      className="login-form-links__action"
                      onClick={(e) => { e.preventDefault(); generate2faSecret({ email: value?.email }).then(() => flashSuccess(dispatch, 'New code sent')); }}
                    >
                      Resend Code
                    </button>
                    <button
                      type="button"
                      className="login-form-links__action"
                      onClick={backFromExpired2FA}
                    >
                      Back
                    </button>
                  </div>
                </form>
              )}
            />
          );
        }
        return (
          <Form
            onSubmit={onExpiredPasswordSubmit}
            validate={validateExpiredPassword}
            initialValues={{
              new_password: '',
              password_confirmation: '',
            }}
            render={({ handleSubmit }) => (
              <form className="form" onSubmit={handleSubmit}>
                <p className="mb-3 text-muted">Your password has expired.</p>
                <Field name="new_password">
                  {({ input, meta }) => (
                    <div className="mb-3">
                      <label htmlFor="newPassword" className="form-label">New Password</label>
                      <input id="newPassword" type="password" {...input} placeholder="New Password" className="form-control" />
                      {meta.touched && meta.error && <span className="form-error">{meta.error}</span>}
                    </div>
                  )}
                </Field>
                <Field name="password_confirmation">
                  {({ input, meta }) => (
                    <div className="mb-3">
                      <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                      <input id="confirmPassword" type="password" {...input} placeholder="Confirm Password" className="form-control" />
                      {meta.touched && meta.error && <span className="form-error">{meta.error}</span>}
                    </div>
                  )}
                </Field>
                <TemplateButton type="submit" className="" disabled={loading} text="Save" />
                <div className="login-form-links">
                  <button
                    type="button"
                    className="login-form-links__action"
                    onClick={backFromPasswordExpired}
                  >
                    Back
                  </button>
                </div>
              </form>
            )}
          />
        );
      }

      return (
      <>
      <LoginAttemptWarningModal
        isOpen={showAttemptWarning}
        onTryAgain={() => setShowAttemptWarning(false)}
        email={userEmail}
      />
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={
          {
            email: userEmail,
            password: userPassword
          }
        }
        render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form className="form" onSubmit={handleSubmit}>
          {/* <div className="card-header">Log in to continue</div> */}
          {verificationRequired ?
            <><Field name="code">
             {({ input, meta }) => (
                 <div className="mb-3">
                    <label htmlFor="loginInputEmail" className="form-label">
                      Code sent to email <span className='text-blue'>{userEmail}</span>
                    </label>
                   <div className="form__form-group-field">
                     <div className="form__form-group-row">
                       <Input placeholder="Enter 2FA code" type="text" {...input} autoFocus />
                       {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                     </div>
                 </div>
               </div>
             )}
          </Field>
          </> : 
          <><Field name="email">
            {({ input, meta }) => (
             <div className="mb-3">
               <label htmlFor="loginInputEmail" className="form-label">Email address</label>
               <Input placeholder="Email" type="text" {...input} autoFocus />
               {meta.touched && meta.error && (
                 <span className="form-error">{meta.error}</span>
               )}
              </div>
            )}
          </Field>
          <Field name="password">
            {({ input, meta }) => (
              <div className="mb-3">
                <label htmlFor="loginInutPassword" className="form-label">Password</label>
                <input id="loginInutPassword" type="password" {...input} placeholder="Password" className="form-control"  />
                {meta.touched && meta.error && <span className="form-error">{meta.error}</span>}
              </div>
            )}
          </Field>
          <div className="float-end">
            <p><a href="/forgot"><small>Forgot a password?</small></a></p>
          </div></>}
          <TemplateButton type="submit" className="" disabled={loading} spinner={loading} text={loading ? 'Signing In...' : 'Sign In'} />
          {!verificationRequired && !passwordExpired && showResendActivationLink && typeof onOpenResendActivation === 'function' && (
            <div className="login-form-links">
              <button
                type="button"
                className="login-form-links__action"
                onClick={onOpenResendActivation}
              >
                Resend activation link
              </button>
            </div>
          )}
          {verificationRequired  && <>
            <div className='login-form-links'>
              <button
                type="button"
                className="login-form-links__action"
                onClick={sendAgain}
              >
                Resend Code
              </button>
              <button
                type="button"
                className="login-form-links__action"
                onClick={backToLogin}
              >
                Back
              </button>
            </div>
          </>}
          </form>
        )}
      />
      </>
    )}

    const FormProgram = () => {
      // console.log(user)

      if( !user ) return 'loading...'

      let loginAs = ''
      const managerRoleOption = isManager
        ? {
            role: 'manager',
            title: 'Manager',
            subtitle: 'Manage your program and team',
          }
        : isLimitedManager
          ? {
              role: 'limited_manager',
              title: 'Limited Manager',
              subtitle: 'Access assigned program tools and approvals',
            }
          : isReadOnlyManager
            ? {
                role: 'read_only_manager',
                title: 'Read-Only Manager',
                subtitle: 'View your program, team, and reporting',
              }
            : null;

      // console.log(user.programRoles)
      // const programOptions = getProgramOptions(user)

      const validate = values => {
        let errors = {};
        if( !program )
        errors.program = "Select a program";
        return errors;
      }
      
      const onSubmit = async values => {
        let programId = values.program?.value;
        handleProgramLogin(programId, loginAs);
      };

      const onSelectProgram = (selectedOption) => {
        // alert(JSON.stringify(selectedOption))
        handleCheckRole(selectedOption.value);
        setProgram( selectedOption )
      };

      return (
      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={
          {
            program
          }
        }
        render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form className="form" onSubmit={handleSubmit}>
          {programOptions.length > 1 ?
          <Field name={'program'}
              parse={
                  (value) => {
                      onSelectProgram(value)
                      return value
                  }
              }
          >
          {({ input, meta }) => (
              <div className="form__form-group">
                  <span className="form__form-group-label">Select your Reward Program</span>
                  <div className="form__form-group-field">
                      <div className="form__form-group-row">
                          <Select
                              options={programOptions}
                              clearable={false}
                              className="react-select"
                              placeholder="Choose a program"
                              classNamePrefix="react-select"
                              value={program}
                              {...input}
                          />
                          {meta.touched && meta.error && <span className="form-error">{meta.error}</span>}
                      </div>
                  </div>
              </div>
          )}
          </Field> :
          <div className="form__form-group">
              <span className="form__form-group-label">Your Reward Program:</span>
              <div className="form__form-group-field">
                  <div className="form__form-group-row">
                      <Input
                          readOnly={true}
                          value={program?.label}
                      />
                  </div>
              </div>
          </div>
          }
          
          <div className="login-role-select">
            {isParticipant && (
              <button
                type="submit"
                className="login-role-btn login-role-btn--participant"
                disabled={loading}
                onClick={() => { loginAs = 'participant'; }}
              >
                <span className="login-role-btn__text">
                  <span className="login-role-btn__title">Participant</span>
                  <span className="login-role-btn__sub">Access your rewards and redemptions</span>
                </span>
              </button>
            )}
            {managerRoleOption && (
              <button
                type="submit"
                className="login-role-btn login-role-btn--manager"
                disabled={loading}
                onClick={() => {
                  loginAs = managerRoleOption.role;
                }}
              >
                <span className="login-role-btn__text">
                  <span className="login-role-btn__title">{managerRoleOption.title}</span>
                  <span className="login-role-btn__sub">{managerRoleOption.subtitle}</span>
                </span>
              </button>
            )}
          </div>
          </form>
        )}
      />
    )}

    return (
      <div className="card w-100">
        <div className="card-header">Sign In</div>
        <div className="card-body mt-3">
          {step === 0 && <FormLogin onSubmit />}
          {step === 1 && <FormProgram onSubmit />}
        </div>
      </div>
    )
  }

  const getProgramOptions = (user) => {
    let options = []
    for (const [key, value] of Object.entries(user.programRoles)) {
      options.push({label: value.name, value: value.id})
    }
    return options
  }

  const CardFormForgot = ()  => {
    return (
      <div className="card w-100">
        <div className="card-header">Forgot Password?</div>
        <div className="card-body mt-3">
          <FormForgot onSubmit />
        </div>
      </div>
    )
  }

  const FormForgot = () => {
    const validate = values => {
      let errors = {};
      if (!values.email) {
        errors.email = "Email is required";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = "Invalid email address";
      }
      return errors;
    }
    const onSubmit = async values => {
      // console.log(values);
      setLoading(true)
      axios.post('/password/forgot', values)
      .then( (res) => {
        console.log(res.data)
        // console.log(res.status == 200)
        if(res.status === 200)  {
          setLoading(false)
        }
      })
      .catch( err => {
        console.log(err)
        // console.log(error.response.data)
        // dispatch(sendFlashMessage(<ApiErrorMessage errors={err.response.data} />, 'alert-danger', 'top'))
        flash422(dispatch, err.response.data)
        setLoading(false)
      })
    };
    return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={
        {
          email: 'arvind.mailtoxsxx@gmail.com'
        }
      }
      render={({ handleSubmit, form, submitting, pristine, values }) => (
      <form className="form" onSubmit={handleSubmit}>
        <Field name="email">
          {({ input, meta }) => (
           <div className="mb-3">
              <label htmlFor="loginInputEmail" className="form-label">Email address</label>
              <input id="loginInputEmail" type="text" {...input} placeholder="Email" className="form-control" />
              {meta.touched && meta.error && <span className="form-error">{meta.error}</span>}
            </div>
          )}
        </Field>
        <TemplateButton type="submit" className="" disabled={loading} text='Submit' />
        </form>
      )}
    />
  )}
  // const FormProgram = () => {
  //   return (
  //     <div>Form 2</div>
  //   )
  // }

  return (
    step === 0 && <CardFormLogin /> || step === 1 && <CardFormLogin /> || step === 3 && <CardFormForgot />
  )
}

export default LogInForm;
